import './styles/sftp-gateway-details.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'
import moment     from 'moment'

import { Card } from 'semantic-ui-react'

import ScrollableItemList from '../components/ScrollableItemList'
import DetailsSection     from '../components/DetailsSection'
import DetailsHeader      from '../components/DetailsHeader'
import Loading            from '../components/Loading'
import JobLogItem         from '../job/JobLogItem'

import api from '../redux/api'

function formatTime(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD h:mm:ss A')
}

const initialState = {
  data:    null,
  loading: true,
  logs:    [],
}

export default class SFTPGatewayDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
  }

  state = { ...initialState }

  componentDidMount() {
    this.loadLog()
  }

  loadLog = () => {
    const { logId } = this.props.match.params

    api.loadSFTPGatewayLog(logId).then((data) => {
      data && this.setState({ loading: false, data })
    })
  }

  _mimicConnectionFromSFTPLogs = () => {
    const { data } = this.state
    const businessLog = data && data.businessLog

    return {
      edges: [
        {
          node: {
            component: (data && data.dataSource && data.dataSource.type == 'SFTP' ? "SFTP_GATEWAY" : 'FTP_GATEWAY'), 
            businessLog: businessLog || [],
          }
        }
      ],
      pageInfo: {
        hasNextPage: false
      }
    }
  }

  render() {
    const { loading, data } = this.state
    const dataSource = data && data.dataSource

    if (loading) return <Loading/>

    const failed    = data.failed

    const timestamp   = formatTime(data.timestamp)
    const statusClass = classnames('status', { success: !data.failed, failed })

    const cardGroupItems = [{
      header: 'Creation Time',
      description: formatTime(data.creationTimestamp),
    }]

    return (
      <div className="sftp-gateway-details">
        <div className="header-row">
          <DetailsHeader title={dataSource && dataSource.type === 'SFTP' ?  "SFTP Gateway Log Details" : "FTP Gateway Log Details"} type={'Job'} description={timestamp}/>

          <div className={statusClass}>
            <div className="status-container">
            
              <div className="item-highlight ui mini message">              
                <div className="title">{'Status'}</div>              
              </div>
            </div>
          </div>
        </div>

        <Card.Group items={cardGroupItems} />

        <div className="details">
          {
            dataSource && (
              <DetailsSection
                title="Data Source"
                name={dataSource.name}
                description={dataSource.description}
                url={`/data-sources/item/${dataSource.id}`}
              />
            )
          }
        </div>

        <div className="sftp-gateway-logs">
          <div className="header">
            <div className="title">Gateway Log</div>
          </div>

          {!loading && <ScrollableItemList
            connection={this._mimicConnectionFromSFTPLogs()}
            loadNextPage={() => {}}
            renderNode={node => <JobLogItem showDebugLogs={false} {...node}/>}
          />
          }       
        </div>
      </div>
    )
  }
}